import { FormControl, Select, MenuItem, SelectChangeEvent, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Language {
  code: string;
  countryCode: string;
  labelKey: string;
}

const LANGUAGES: Language[] = [
  { code: 'en', countryCode: 'gb', labelKey: 'language.english' },
  { code: 'el', countryCode: 'gr', labelKey: 'language.greek' },
];

function FlagIcon({ countryCode }: { countryCode: string }) {
  return (
    <Box
      component="img"
      src={`https://flagcdn.com/w40/${countryCode}.png`}
      srcSet={`https://flagcdn.com/w80/${countryCode}.png 2x`}
      alt=""
      sx={{
        width: 24,
        height: 16,
        objectFit: 'cover',
        borderRadius: '2px',
        boxShadow: '0 0 1px rgba(0,0,0,0.3)',
      }}
    />
  );
}

export function LanguageSelector() {
  const { i18n, t } = useTranslation();

  const handleChange = (event: SelectChangeEvent<string>) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang);
  };

  // Get the base language code (handle 'en-US' -> 'en')
  const currentLang = i18n.language.split('-')[0];

  return (
    <FormControl size="small" sx={{ minWidth: 140 }}>
      <Select
        value={currentLang}
        onChange={handleChange}
        sx={{
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            py: 0.5,
          },
        }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem key={lang.code} value={lang.code} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <FlagIcon countryCode={lang.countryCode} />
            {t(lang.labelKey)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
